import React from 'react';

import { importIcon, songs, UpRightFromSquare } from '@/assets/icons';
import {
	ISetting,
	ISettingTitle,
	SettingCard,
	SettingSectionTitle,
} from '@/components/shared/SettingCard';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { List } from '@material-ui/core';

import {
	ESongsSettingsDisplayState,
	IPropsSongsSettingsDisplay,
} from './SongsSettingsPanel';
import styles from './SongsSettingsRoot.module.scss';

export const SongsSettingsRoot: React.FC<IPropsSongsSettingsDisplay> = (
	props,
) => {
	const fireViewChartRepositoryEvent = useAnalyticsEvent(
		'Songlist_Settings_View_Chart_Repository',
	);
	const fireViewImportSonglistEvent = useAnalyticsEvent(
		'Songlist_Settings_View_Import_Songlist',
	);

	const settings: Array<ISetting | ISettingTitle> = [
		{
			type: 'setting',
			// icon: upRightFromSquare,
			title: 'Chart repository',
			onClick: () => {
				props.pushDisplayState(
					ESongsSettingsDisplayState.CHART_REPOSITORY,
				);
				fireViewChartRepositoryEvent();
			},
		},
	];

	return (
		<div>
			<h1 className={styles['songs-settings-root__heading']}>
				Songs settings
			</h1>
			<List className={styles['songs-settings-root__list']}>
				{settings.map((item, index) => {
					if (item.type === 'title') {
						return <SettingSectionTitle key={index} {...item} />;
					} else if (item.type === 'setting') {
						return <SettingCard key={index} {...item} />;
					}
					return null;
				})}
			</List>
			<div className="vsb-20" />
		</div>
	);
};
